import { render, staticRenderFns } from "./MaterijalPreview.vue?vue&type=template&id=0b9629bb&scoped=true"
import script from "./MaterijalPreview.vue?vue&type=script&lang=js"
export * from "./MaterijalPreview.vue?vue&type=script&lang=js"
import style0 from "./MaterijalPreview.vue?vue&type=style&index=0&id=0b9629bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9629bb",
  null
  
)

export default component.exports